/* eslint-disable */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { Component } from "react";

export type IconProps = {
  icon: IconName | string;
  iconLibrary?: IconPrefix;
  className?: string;
  fontSize?: string | number;
  style?: object;
  spin?: boolean;
  onClick?: (props?: any) => void;
};

export class IconErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // @ts-ignore
  render() {
    const { state, props } = this;
    // @ts-ignore
    if (!props || state.hasError){
      debugger
      return null
    };
    return props.children;
  }
}

export function Icon({
  icon,
  iconLibrary = 'fad',
  className='',
  fontSize,
  spin = false,
  style = {},
  ...props
}: IconProps) {
  // More robust validation
  if (!icon || !iconLibrary || icon === 'undefined' || icon === 'null') {
    console.warn('[Icon] Invalid icon prop:', { icon, iconLibrary });
    return null;
  }
  
  try {
    return (
        <FontAwesomeIcon
          // @ts-ignore
          icon={[iconLibrary, icon]}
          className={className}
          spin={spin}
          style={{
            ...style,
            ...(fontSize && { fontSize })
          }}
          {...props}
        />
    );
  } catch (error) {
    console.error('[Icon] Error rendering icon:', { icon, iconLibrary, error });
    return null;
  }
}

export default Icon;
